import PropTypes from 'prop-types';
import React from 'react';
import xmark from '../../../../resources/x-mark.png';
import { Button, ModalComponent, RadioInput } from '../../../common/components';
import browserPlatform from '../../../platform/browser';
import { generateTypes } from '../../../utils/constant';

const MonthlyReportPopup = ({
  isOpen,
  toggle,
  onConfirm,
  onCancel,
  message,
  confirmBtnText,
  statusPayload,
  description,
  setGenerateType,
  generateType,
}) => {
  return (
    <div>
      {message === 'Status' && (
        <ModalComponent isOpen={isOpen} toggle={toggle} className="acc-success-modal-1 lg bulk">
          <div className="acconut-number-modal">
            <div className="account-heading-modal">
              <div className="bulk-nav">
                <div className="save-change-h bulk-heading mt-2">{message}</div>
                <img src={xmark} alt="close" className="x-mark ml-auto mt-0" onClick={onConfirm} />
              </div>
              <div className="acconut-number-modal-div my-3 ml-3 mb-0 mr-3">
                <table>
                  <thead>
                    <tr>
                      <th>
                        <div>Total Contracts</div>
                      </th>
                      <th>
                        <div>Status</div>
                      </th>
                      <th>
                        <div>Category</div>
                      </th>
                      <th>
                        <div>Blob link</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {statusPayload?.data?.data?.result?.map((ele, eleIndex) => {
                      return (
                        <tr key={eleIndex}>
                          <td>
                            <div>{ele.agreementIdsCount} </div>
                          </td>
                          <td>
                            <div className="pr-5">{ele.status}</div>
                          </td>
                          <td>
                            <div className="pr-3">{ele.category}</div>
                          </td>
                          <td>
                            <div className="blob-link-monthly">
                              <a
                                href={ele.blobLink}
                                onClick={(e) => {
                                  e.preventDefault();
                                  browserPlatform.openExternal(ele.blobLink);
                                }}
                              >
                                {ele.blobLink}
                              </a>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ModalComponent>
      )}
      {message === 'Error Occured' && (
        <ModalComponent isOpen={isOpen} toggle={toggle} className="acc-success-modal-1 lg bulk">
          <div className="acconut-number-modal">
            <div className="bulk-nav">
              <div className="save-change-h bulk-heading">Status</div>
              <img src={xmark} alt="close" className="x-mark ml-auto mt-0" onClick={onConfirm} />
            </div>
            <div className="my-3">
              <div className="acc-number-created-1">
                The following contract numbers are here and has been sent over email as well.
              </div>
              <div className="my-3 ml-3 mb-0 mr-3">
                <table>
                  <thead>
                    <tr>
                      <th>
                        <div>Agreement Id</div>
                      </th>
                      <th>
                        <div>Category</div>
                      </th>
                      <th>
                        <div>Contract Number</div>
                      </th>
                      <th>
                        <div>Generate Status</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {statusPayload?.data?.data?.error?.map((ele, eleIndex) => {
                      return (
                        <tr key={eleIndex}>
                          <td>
                            <div>{ele.agreementId}</div>
                          </td>
                          <td>
                            <div>{ele.category}</div>
                          </td>
                          <td>
                            <div>{ele.contractNumber}</div>
                          </td>
                          <td>
                            <div>{ele.generateStatus}</div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ModalComponent>
      )}
      {message === 'Monthly Generation' && (
        <ModalComponent
          isOpen={isOpen}
          toggle={toggle}
          className="acc-success-modal-1 lg success-generation"
        >
          <div className="acconut-number-modal">
            <div className="bulk-nav">
              <div className="save-change-h bulk-heading">{message}</div>
              <img src={xmark} alt="close" className="x-mark ml-auto mt-0" onClick={onConfirm} />
            </div>
            <div className="acconut-number-modal-div my-3">
              <div className="acc-number-created-1">{description}</div>
              <Button color="primary" className="atd-btn acc-btn mr-4 my-3 xl" onClick={onConfirm}>
                {confirmBtnText}
              </Button>
            </div>
          </div>
        </ModalComponent>
      )}
      {message === 'Summary Table Status' && (
        <ModalComponent
          isOpen={isOpen}
          toggle={toggle}
          className="acc-success-modal-1 lg success-generation"
        >
          <div className="acconut-number-modal">
            <div className="bulk-nav">
              <div className="save-change-h bulk-heading">{message}</div>
              <img src={xmark} alt="close" className="x-mark ml-auto mt-0" onClick={onCancel} />
            </div>
            <div className="acconut-number-modal-div my-3">
              <div className="acc-number-created-1">{description}</div>

              <div className="radios">
                {generateTypes.map((item) => {
                  return (
                    <React.Fragment key={item.value}>
                      <RadioInput
                        formInput={false}
                        name="generateType"
                        label={item.label}
                        value={item.value}
                        onChange={() => {
                          setGenerateType(item.value);
                        }}
                      />
                    </React.Fragment>
                  );
                })}
              </div>
              <Button
                color="primary"
                className="atd-btn acc-btn mr-4 my-3 xl"
                disabled={!generateType}
                onClick={onConfirm}
              >
                {confirmBtnText}
              </Button>
            </div>
          </div>
        </ModalComponent>
      )}
    </div>
  );
};

MonthlyReportPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  confirmBtnText: PropTypes.string.isRequired,
  statusPayload: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  description: PropTypes.string,
  setGenerateType: PropTypes.func.isRequired,
  generateType: PropTypes.string,
};

MonthlyReportPopup.defaultProps = {
  description: '',
  generateType: '',
};

export default MonthlyReportPopup;
